<template lang="pug">
#user_host_modal_wrapper
  b-modal#set-user-host(title='Webサイトのドメインを登録',size="lg",'hide-footer')
    .callout.callout-info
      p
        | 現在ご利用のプランにおいて、SiteLeadを導入できるWebサイトのドメインは
        strong 1個まで
        | です。
        br
        | 以下のフォームからWebサイトのドメインを登録してください。
        br
        | Webサイトのドメインは、後から管理画面左側の【設定】⇒【登録ドメイン】より変更することができます。

    .form-group.mg-4
      label SiteLeadを導入するWebサイトのドメイン
      input#creative_title.form-control(type='text',
      name='form_url',
      v-model="form_url"
      placeholder='例) https://kenga.tech',
      @blur='$v.form_url.$touch',
      :class="{ 'is-invalid': $v.form_url.$invalid && $v.form_url.$dirty, 'is-valid': !$v.form_url.$invalid && $v.form_url.$dirty }")
      .invalid-feedback(v-if="!$v.form_url.required && $v.form_url.$dirty") 入力してください
      .invalid-feedback(v-if="!$v.form_url.url && $v.form_url.$dirty") URL形式が正しくありません
      .mt-3.text-right
        template(v-if="user_host!=''")
          button.btn.btn-primary(@click="submit") ドメインを更新
        template(v-else)
          button.btn.btn-primary(@click="submit") ドメインを登録
    p Premiumプラン以上の有料プラン場合、登録可能なWebサイトのドメイン数は無制限となり、お持ちの全てのWebサイトでSiteLeadをご利用いただくことができます。
    a.btn.btn-primary.btn-sm(:href="plan_page_url") 有料プランページはこちら
</template>

<script>
import UserApi from '../../apis/user'

import { mapState } from 'vuex'

import { required, url } from 'vuelidate/lib/validators'

import Vue from 'vue'

export default {
  data(){
    return {
      form_url: this.user_host
    }
  },
  props: {
    user_host: String,
    plan_page_url: String,
    plan_name: String,
  },
  methods: {
    async submit(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        //送信処理
        this.$v.$reset()
        // ディレクトリは削除して登録
        const urlObject = new URL(this.form_url);
        const host = `${urlObject.protocol}//${urlObject.hostname}`;
        const { data } = await UserApi.update_host({url: host})
        if(!data.is_error){
          this.$store.commit("user/setHost", host)
          this.$bvModal.hide('set-user-host')
        } else {
          alert("エラーが発生しました")
        }
      }
    },
  },
  mounted(){
  },
  watch: {
  },
  validations: {
    form_url: {
      required,
      url
    }
  },
  async mounted(){
    await Vue.nextTick()
    if(this.user_host == ''){
      this.$bvModal.show('set-user-host')
    }
  },
}
</script>
<style lang="scss" scoped>
</style>
